module.exports = __webpack_public_path__ + "static/media/hackerman.c7973ccb.mp4";